import { useField } from "formik";
import { Input, InputProps } from "@/components/base/Input.tsx";
import { Label } from "@/components/base/Label.tsx";
import { Error } from "@/components/base/Error.tsx";
import { Timestamp } from "firebase/firestore";
import { firestoreToDateTime } from "@/lib/utils.ts";
import { useMemo } from "react";
import { format, parse } from "date-fns";

interface FormikDateInputProps extends InputProps {
  name: string;
  type: string;
  placeholder?: string;
  label?: string;
}

export const FormikDateInput = (props: FormikDateInputProps) => {
  const [field, meta, helpers] = useField(props);
  const { label } = props;
  const value = useMemo(
    () =>
      firestoreToDateTime(field.value as Date | Timestamp | undefined | null),
    [field]
  );
  return (
    <div>
      {label && <Label htmlFor={props.id}>{label}</Label>}
      <Input
        value={value ? format(value, "yyyy-MM-dd") : undefined}
        onChange={(event) =>
          helpers.setValue(parse(event.target.value, "yyyy-MM-dd", new Date()))
        }
        {...props}
      />
      {meta.touched && meta.error ? <Error error={meta.error} /> : null}
    </div>
  );
};
